import * as React from "react";
import { forwardRef } from "react";
const SvgCheck2 = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", width: "1em", height: "1em", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M7.987 17.243L2.77 12.026 1 13.8l6.987 6.983L23 5.77 21.23 4z" }));
const ForwardRef = forwardRef(SvgCheck2);
export default ForwardRef;
